<template>
    <i v-tooltip="tooltipText">
        <fa icon="paper-plane" style="color: #EAE064;"/>
    </i>
</template>

<script>
import Tooltip from 'primevue/tooltip'

export default {
    name: 'donePaperIcon',
    props: ['tooltipText'],
    emits: [],
    directives: {
        'tooltip': Tooltip,
    },
}
</script>

<style scoped>
</style>

